export default __webpack_public_path__ + "static/media/healthcare-banner.3c6b2783.svg";